export const FREE_MONTH_OFFER_OPTION_VALUES = {
  YES: 'yes',
  NO: 'no',
}

export const FREE_PERIOD_IN_MONTHS = 1

export const FREE_MONTH_OFFER_SCREEN_QUESTION = '1 month for free'

export const FREE_MONTH_OFFER_BENEFITS = [
  'retention.freeMonthOffer.benefits.fullAccess',
  'retention.freeMonthOffer.benefits.learningJourney',
  'retention.freeMonthOffer.benefits.noChargeNextMonth',
]
